import {Parallax, Button, Alert, Spinner, Card} from '../components';
import FractionsWidget from '../components/Widgets/Fractions';
import FractionsStripWidget from '../components/Widgets/FractionsStrip';
import ScreenContainer from '../layout/ScreenContainer';
import ReadingPerWords from '../components/Widgets/ReadingPerWords';
import ManualReadingPerWords from '../components/Widgets/ManualReadingPerWords';
import AutomaticReading from '../components/Widgets/AutomaticReading';
import Synonyms from '../components/Widgets/Synonyms';
import RadioButton from '../components/Inputs/Radio';
import Modal from '../components/Modal';
import Quiz from '../components/Widgets/Quiz';
/**
 * You can register global components here
 */
console.log(Alert, Spinner);
const globalComponents = {
  install (Vue) {
    Vue.component(Parallax.name, Parallax)
    Vue.component(Button.name, Button)
    Vue.component(Alert.name, Alert)
    Vue.component(Spinner.name, Spinner)
    Vue.component(Card.name, Card)
    Vue.component(Modal.name, Modal)
    Vue.component(RadioButton.name, RadioButton)
    // Layout
    Vue.component(ScreenContainer.name, ScreenContainer)
    // Widgets
    Vue.component(FractionsWidget.name, FractionsWidget)
    Vue.component(FractionsStripWidget.name, FractionsStripWidget)
    Vue.component(ReadingPerWords.name, ReadingPerWords)
    Vue.component(ManualReadingPerWords.name, ManualReadingPerWords)
    Vue.component(AutomaticReading.name, AutomaticReading)
    Vue.component(Synonyms.name, Synonyms)
    Vue.component(Quiz.name, Quiz)
  }
}

export default globalComponents
